import type { SectionProps } from "../context";
import { field } from "../context";
import { CARD_HOVER, Container, STACK, STAGGER, SectionHeader, SectionShell, cx } from "../ui";

const COLS = ["", "@3xl:grid-cols-1", "@3xl:grid-cols-2", "@3xl:grid-cols-3", "@3xl:grid-cols-4", "@3xl:grid-cols-5", "@3xl:grid-cols-6"] as const;

export function Stats({ node, ctx }: SectionProps<"stats">) {
  const c = node.content;
  const n = Math.min(c.items.length, 6);
  const hasHeader = !!(c.title || c.eyebrow);
  if (node.variant === "cards") {
    return (
      <SectionShell ctx={ctx} node={node} labelledBy={!!c.title}>
        <Container>
          <SectionHeader ctx={ctx} node={node} eyebrow={c.eyebrow} title={c.title} align="center" />
          <dl className={cx(hasHeader && STACK, STAGGER, "grid grid-cols-2 gap-4 @3xl:gap-6", n >= 3 && "@3xl:grid-cols-3", n === 4 && "@5xl:grid-cols-4")}>
            {c.items.map((item, i) => (
              <div key={i} className={cx("relative flex flex-col-reverse gap-3 overflow-hidden rounded-site-md border border-site-border bg-site-surface p-6 shadow-site-sm @3xl:p-8", CARD_HOVER)}>
                <span aria-hidden="true" className="absolute inset-y-0 left-0 w-1 bg-site-primary" />
                <dt className="text-sm font-medium text-site-muted @3xl:text-base" {...field(ctx, `content.items.${i}.label`)}>
                  {item.label}
                </dt>
                <dd className="baze-heading text-4xl leading-none text-site-primary tabular-nums @3xl:text-5xl" {...field(ctx, `content.items.${i}.value`)}>
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </Container>
      </SectionShell>
    );
  }

  return (
    <SectionShell ctx={ctx} node={node} labelledBy={!!c.title}>
      <Container>
        <SectionHeader ctx={ctx} node={node} eyebrow={c.eyebrow} title={c.title} align="center" />
        <dl
          className={cx(
            hasHeader && STACK,
            STAGGER,
            "grid gap-y-10",
            n === 1 ? "grid-cols-1" : "grid-cols-2",
            COLS[n],
            n > 1 && "@3xl:divide-x @3xl:divide-site-border",
          )}
        >
          {c.items.map((item, i) => (
            <div key={i} className="flex flex-col-reverse items-center gap-2 px-4 text-center">
              <dt className="text-sm font-medium text-site-muted @3xl:text-base" {...field(ctx, `content.items.${i}.label`)}>
                {item.label}
              </dt>
              <dd className="baze-heading text-4xl leading-none tabular-nums @3xl:text-5xl @5xl:text-6xl" {...field(ctx, `content.items.${i}.value`)}>
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </Container>
    </SectionShell>
  );
}
